export default __webpack_public_path__ + "static/media/20210819182532.72c28bce.png";